import React from "react";
import { RemovePng } from "../../assets";
import "./AcInputText.css";

const PaymentLimitInput = ({
  type,
  name,
  placeholder,
  value,
  onChange,
  label,
  maxLength,
  disabled,
  error,
  onkeypress,
  id,
  defaultValue,
  onBlur,
  style,
  required,
  min,
  max,
}) => {
  return (
    <div className="payment-inputText-input-wrapper">
      <label className="payment-inputText-label" htmlFor={label}>
        {label}
      </label>
      <div className="payment-inputText-input-container">
        <input
          className="payment-inputText-input"
          type={type}
          name={name}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          disabled={disabled}
          onkeypress={onkeypress}
          id={id}
          defaultValue={defaultValue}
          onBlur={onBlur}
          style={style}
          required={required}
          min={min}
          max={max}
        />
      </div>
      {error ? (
        <div className="payment-inputText-error-container">
          <img
            className="inputText-img"
            style={{ verticalAlign: "middle" }}
            src={RemovePng}
            alt=""
          />
          <span>{error}</span>
        </div>
      ) : null}
    </div>
  );
};

export default PaymentLimitInput;
